import { Box, Button, Grid2, Stack, Typography } from '@mui/material';

import type { Spread } from '@/data/spreads';
import type { DrawnEntry } from '@/types/reading';

import RevealedCard from './RevealedCard';
import {
  revealedReadingButtonStackSx,
  revealedReadingGridSx,
  revealedReadingTitleSx,
} from './RevealedReading.styles';

interface Props {
  spread: Spread;
  drawn: DrawnEntry[];
  onNewReading: () => void;
  onReshuffle: () => void;
}

function RevealedReading({ spread, drawn, onNewReading, onReshuffle }: Props) {
  if (drawn.length === 0) return null;

  const { gridSize, centered } = spread.layout;

  return (
    <Box>
      <Typography variant="h5" sx={revealedReadingTitleSx}>
        Your {spread.label} Reading
      </Typography>

      <Grid2 container spacing={3} sx={revealedReadingGridSx(centered)}>
        {drawn.map((entry) => (
          <Grid2 key={entry.position} size={gridSize}>
            <RevealedCard entry={entry} />
          </Grid2>
        ))}
      </Grid2>

      <Stack sx={revealedReadingButtonStackSx}>
        <Button variant="contained" onClick={onNewReading}>
          New Reading
        </Button>
        <Button variant="outlined" onClick={onReshuffle}>
          Reshuffle
        </Button>
      </Stack>
    </Box>
  );
}

export default RevealedReading;
